// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1bxcy","modalForm":"UpgradeEpcsModal_modalForm__mMzir","modalFooter":"UpgradeEpcsModal_modalFooter__3gYKE"};